import  {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../styles/dropdown-section.css";
import classNames from "classnames";

const RollerButton = ({
    switchedIcon, 
    unswitchedIcon, switchedColor, 
    unswitchedColor, 
    switched,
    clickAction
}) => {

   
    return (
        <button 
            className={classNames('switch-button',{'switched': switched})}
            style={{
                backgroundColor: switched ? switchedColor : unswitchedColor
            }}
            onClick={clickAction}
        >
            <FontAwesomeIcon 
                icon={switched ? switchedIcon : unswitchedIcon}
                color="#fff" 
            />
        </button>
    )
}

export const AppSwitch = ({
    switchedIcon, 
    unswitchedIcon, 
    switchedColor, 
    unswitchedColor,
    onSwitch
}) => {
    const [switched, setSwitched] = useState(false);
    const toggleSwitch = (e) => {
        e.preventDefault();
        onSwitch();
        setSwitched((v) => !v)
    };
    return (
        <div 
            className="switch-groove"
            onClick={toggleSwitch}
            style={{backgroundColor: switched ? unswitchedColor : switchedColor}}
        >
            <RollerButton 
                switchedIcon={switchedIcon} 
                unswitchedIcon={unswitchedIcon}
                switchedColor={switchedColor}
                unswitchedColor={unswitchedColor}
                switchMethod={toggleSwitch}
                switched={switched}
                clickAction={toggleSwitch}
            />
        </div>
    )
}